module.exports = __webpack_public_path__ + "img/reserve_bg.b6deeb35.png";